import { apiClient } from '@/lib/api-client';
import { User as FirebaseUser } from 'firebase/auth';

export interface CreateUserRequest {
  userId: string;
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  temporaryPassword?: string;
  roles?: string[];
}

export interface CreateUserResponse {
  message: string;
  userId?: string;
}

export class AuthService {
  /**
   * Create user in backend after Firebase authentication
   */
  async createUser(firebaseUser: FirebaseUser): Promise<CreateUserResponse> {
    const userData: CreateUserRequest = {
      userId: firebaseUser.uid,
      username: firebaseUser.email || firebaseUser.uid,
      email: firebaseUser.email || '',
      firstName: firebaseUser.displayName?.split(' ')[0],
      lastName: firebaseUser.displayName?.split(' ').slice(1).join(' '),
    };

    return await apiClient.post<CreateUserResponse>('/auth/users', userData);
  }

  /**
   * Check if user exists in backend
   */
  async checkUserExists(userId: string): Promise<boolean> {
    try {
      await apiClient.get(`/auth/users/${userId}`);
      return true;
    } catch (error) {
      return false;
    }
  }
}

export const authService = new AuthService();
